import React from "react";
import Calendar from "react-calendar";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import "react-calendar/dist/Calendar.css";
import "assets/css/MiniCalendar.css";

const MiniCalendar = (props) => {
  const {
    value,
    onChange,
    isFutureDateDisabled = false,
    isPastDateDisabled = false,
    ...others
  } = props;

  const tileDisabled = ({ date }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);

    if (isFutureDateDisabled && checkDate > today) return true;
    if (isPastDateDisabled && checkDate < today) return true;
    return false;
  };

  return (
    <div className="flex h-full w-full max-w-full flex-col rounded-card border border-line bg-surface px-3 py-4 text-fg shadow-overlay">
      <Calendar
        onChange={onChange}
        value={value || ""}
        prevLabel={<MdChevronLeft aria-hidden="true" className="h-5 w-5" />}
        nextLabel={<MdChevronRight aria-hidden="true" className="h-5 w-5" />}
        prevAriaLabel="Previous month"
        nextAriaLabel="Next month"
        tileDisabled={tileDisabled}
        {...others}
      />
    </div>
  );
};

export default MiniCalendar;
